/**
 * Finishing - Navigation
 *
 * JS pour la gestion de la navigation
 *
 * @since       30.10.2015
 * @version     1.0.0.0
 * @author      e-novinfo
 * @copyright   e-novinfo 2015
 */

/************************************/
/********** DOCUMENT READY **********/
/************************************/

jQuery( document ).ready( function() {
    
    if ( window.matchMedia( '( min-width: 991px )' ).matches ) {
    
        jQuery( '.navbar-default .navbar-nav .dropdown-toggle' ).on( 'click', function ( e ) {
            
            $parentNavItem = jQuery( this ).parent( 'li' );
            
            if ( !jQuery( $parentNavItem ).hasClass( "active" ) ) {
                jQuery( $parentNavItem ).removeClass( "active" );
            }
            
        //END jQuery( document ).on( 'click', function (e) 
        }); 
     
    //END if ( window.matchMedia( '( min-width: 1025px )' ).matches ) 
    }

//END jQuery( document ).ready
});
